import AuthService from "./AuthService";
import ApiService from "./ApiService";

class CompanyService extends ApiService{
    constructor(authService) {
        super();
        this._locale = 'ru';
        this._authService = authService;
        this._generalData = '/profile/company/get-general-data';
        this._saveData = '/profile/company/save-data';
        this._saveImage = '/profile/company/save-avatar';
        this._deleteAvatar = '/profile/company/delete-avatar';
        this._getCompany = '/company/';
        this._getCompanyRate = '/company/rate/get';
        this._setCompanyRate = '/company/rate/set';
        this._getCompanyFeedbacks = '/company/feedback/list';
        this._getCompanies = '/company/get-all';
        this._createCompanyFeedback = '/company/feedback/create';
        this._authMe = '/auth/me';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getGeneralData() {
        return this.postResource(this._generalData, {}, this.getBaseHeaders());
    }
    saveData(data) {
        return this.postResource(this._saveData, data, this.getBaseHeaders());
    }
    saveImage(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._saveImage, data, headers);
    }
    deleteAvatar(imageData) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._deleteAvatar, imageData, headers);
    }
    getCompany(id) {
        return this.postResource(this._getCompany + id, {}, this.getBaseHeaders());
    }
    getCompanyRate(id) {
        const params = {companyId: id};

        return this.postResource(this._getCompanyRate, params, this.getBaseHeaders());
    }
    setCompanyRate(params) {

        return this.postResource(this._setCompanyRate, params, this.getBaseHeaders());
    }
    getCompanyFeedback(id) {
        const params = {companyId: id};

        return this.postResource(this._getCompanyFeedbacks, params, this.getBaseHeaders());
    }
    getCompanies() {
        return this.postResource(this._getCompanies, {}, this.getBaseHeaders());
    }
    createCompanyFeedback(params) {

        return this.postResource(this._createCompanyFeedback, params, this._authService.getAuthHeader());
    }
    getUser() {
        return this.postResource(this._authMe,  this.getBaseHeaders());
    }
}

const companyService = new CompanyService(AuthService);

export default companyService;
